/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 11.25a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0zM11.25 5a6.25 6.25 0 103.67 11.31 1 1 0 00.123.147l2.25 2.25a1 1 0 001.414-1.414l-2.25-2.25a1 1 0 00-.148-.122A6.25 6.25 0 0011.25 5z" _fill="#B1ADC2"/>'
  }
})
